/*
 * Copyright (c) 2019 brightlamp
 */

import Axios from 'axios';
import axiosRetry from 'axios-retry';
import { firebaseAuth } from '@/firebase/firebase'

const axiosInit = async (anonymous = false, s3Mode = false) =>
{
    const axios = Axios.create(
    {
        baseURL: !s3Mode ? process.env.VUE_APP_SERVER_URL + process.env.VUE_APP_ROOT_CONTEXT : undefined,
        headers: !s3Mode ? !anonymous ? {Authorization: `Bearer ${await firebaseAuth.currentUser.getIdToken()}`} : {Authorization: 'Bearer 0'} : undefined
    })
    axiosRetry(axios, {retries: 3, retryDelay: axiosRetry.exponentialDelay, shouldResetTimeout: false, retryCondition: (_error) => _error.response.status === 408 || _error.response.status === 500 || _error.response.status === 502 || _error.response.status === 503 || _error.response.status === 504});
    return axios
};

export { axiosInit }